import { Suspense, lazy, startTransition, useCallback, useDeferredValue, useEffect, useMemo, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import hotel_icon from '../../assets/hotel_icon.png';
import train_homepage_icon from '../../assets/train_homepage_icon.png';
import slugify from '../../utils/slugify';
import PageHelmet from '../SEO/PageHelmet';
import { shouldRenderHomepageMascot } from './homepageMascot';
import './styles/Homepage.css';
// import LanguageIcon from '@mui/icons-material/Language';

import { AutoAwesome } from '@mui/icons-material';
import {
  Box,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { fetchData } from '../../apiconfig';
import playicon from '../../assets/PlayIcon.png';
import woman_icon_without_bg from '../../assets/woman_icon_without_bg-400.webp';
import { BACKEND_URL } from '../../config/backendConfig';
import FlightForm from './FlightForm';
import HotelForm from './HotelForm';
import TrainForm from './TrainForm';
import FlightOneWayRoundTripSearchBar from './FlightOneWayRoundTripSearchBar';
// import { Box, Typography } from '@mui/material';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import MapIcon from '@mui/icons-material/Map';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useLocation, useNavigate } from 'react-router-dom';
import { openAuthModal, useAuth } from '../../features/auth';
import { SEO_DEFAULTS } from '../../config/companyConfig';
import { FAQ_TRUST_ITEMS, HOME_FAQS } from '../../config/faqContent';
import { HOME_FAQ_PREVIEW_COUNT } from '../common/faq.constants';
import FAQJsonLd from '../common/FAQJsonLd';
import MountWhenOpened from '../common/MountWhenOpened';
import { buildHomepageSchema } from '../../content/seo/schema/homepage';
import {
  formTypeAfterHomepageNavigation,
  formTypeFromHomepagePath,
  homepageFormTypeFromStorage,
} from '../Header/homepageTabChange';
import MobileHeader from '../Header/MobileHeader';
import YovoTripHeader from '../Header/YovoTripHeader';
import MobileBottomNav from './MobileBottomNav';
import NearViewport from './NearViewport';
import DestinationGallerySkeleton from './DestinationGallerySkeleton';
import FeaturedDestinationSection from './FeaturedDestinationSection';
import TrendingSpotlightSection from './TrendingSpotlightSection';
import { applyHomepageSections } from './homepageSections';
import { datePickerStyles } from './homepageDatePickerStyles';
import {
  homepageAiGuideClusterSx,
  homepageAiGuideIconSx,
  homepageAiGuideInputSx,
  homepageAiGuideMascotSx,
  homepageAiGuideRowSx,
  homepageAiGuideSendIconSx,
  homepageAiGuideSendSx,
  homepageAiGuideSx,
  homepageAiGuideTitleSx,
  homepageBannerSlotSx,
  homepageContentSx,
  homepageFaqSx,
  homepageFormColumnSx,
  homepageHeaderHostSx,
  homepageMainSx,
  homepageRootSx,
  homepageSearchCardSx,
  homepageSearchSlotSx,
  homepageTestimonialsInnerSx,
  homepageTestimonialsSx,
} from './homepageLayout.styles';
import { sectionIdMap } from './enums';
import { PRODUCTS } from '../campaigns/config/products';
import { HOST_GROTESK_FAMILY } from '../../theme/tokens/typography';
import {
  BUCKET_LIST_DESCRIPTION_FALLBACK,
  BUCKET_LIST_ICON_COLOR,
  BUCKET_LIST_TITLE_FALLBACK,
  HIDDEN_GEMS_DESCRIPTION_FALLBACK,
  HIDDEN_GEMS_ICON_COLOR,
  HIDDEN_GEMS_TITLE_FALLBACK,
  INTO_THE_WILD_DESCRIPTION_FALLBACK,
  INTO_THE_WILD_ICON_COLOR,
  INTO_THE_WILD_TITLE_FALLBACK,
  TROPICAL_PARADISE_DESCRIPTION_FALLBACK,
  TROPICAL_PARADISE_ICON_COLOR,
  TROPICAL_PARADISE_TITLE_FALLBACK,
  TRENDING_SPOTLIGHT_DESCRIPTION_FALLBACK,
  TRENDING_SPOTLIGHT_ICON_COLOR,
  TRENDING_SPOTLIGHT_TITLE_FALLBACK,
} from './homepageCarousel.constants';
const MobileChatbotOverlay = lazy(() => import('./MobileChatbotOverlay'));
const RegionalSettingsModal = lazy(() => import('./RegionalSettingsModal'));
const HomepagePopup = lazy(() => import('./HomepagePopup'));
const HomepageBannerCoordinator = lazy(() => import('./HomepageBannerCoordinator'));
const TestimonialsSection = lazy(() => import('../testimonials/TestimonialsSection'));
const FAQTrustStrip = lazy(() => import('../common/FAQTrustStrip'));
const FAQSection = lazy(() => import('../common/FAQSection'));
const GlobalFooter = lazy(() => import('../common/GlobalFooter/GlobalFooter'));
const DestinationGalleryGrid = lazy(() => import('./DestinationGalleryGrid'));

/**
 * Revert mobile chatbot: set to `true` to show the fixed right chatbot sidebar again on small viewports.
 * When `false`, sidebar only renders from the `md` breakpoint up (tablet/desktop).
 */
const SHOW_CHATBOT_SIDEBAR_ON_MOBILE = false;

const Homepage = () => {
  // State for managing flight form data
  // console.log("Homepage On state change:")
  const [flightFormState, setFlightFormState] = useState({
    tripType: 'oneway',
    multiCitySegments: []
  });

  const location = useLocation();
  const navigate = useNavigate();

  // State to manage active form type — URL path takes priority over localStorage
  const [activeFormType, setActiveFormType] = useState(() => {
    const path = location.pathname;
    if (path === '/flights') return 'flight';
    if (path === '/hotels') return 'hotel';
    if (path === '/trains') return 'train';
    const savedActiveForm = localStorage.getItem('yovo_active_form_type');
    return savedActiveForm || 'flight';
  });

  /** Headers show the tapped tab at once. The form below follows in a background render, so a tab
   *  tap paints immediately instead of waiting for one search form to unmount and the next to mount (INP). */
  const shownFormType = useDeferredValue(activeFormType);
  const handleFlightFormStateChange = useCallback((newState) => {
    // console.log("Prateek nair")
    setFlightFormState(newState);
  }, []);

  // Handle train form state changes
  const handleTrainFormStateChange = useCallback((newState) => {
    // Similar to flight form state handling
    // State change handled silently
  }, []);

  // Handle hotel form state changes
  const handleHotelFormStateChange = useCallback((newState) => {
    // Similar to flight form state handling
    // State change handled silently
  }, []);

  // Handle auth required callback - memoized to prevent re-renders
  const handleAuthRequired = useCallback(() => {
    openAuthModal();
  }, []);

  const formTypeToPath = { flight: '/flights', hotel: '/hotels', train: '/trains' };
  /** Tab the user just tapped. The old URL must not paint over it. */
  const requestedFormTypeRef = useRef(null);

  // Function to switch between forms — updates URL, localStorage, and cross-tab sync
  const switchToForm = useCallback((formType) => {
    requestedFormTypeRef.current = formType;
    setActiveFormType(formType);
    localStorage.setItem('yovo_active_form_type', formType);
    window.dispatchEvent(new CustomEvent('localStorageChange', {
      detail: { key: 'yovo_active_form_type', newValue: formType },
    }));
    const targetPath = formTypeToPath[formType] || '/flights';
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  /** Pathname wins on /flights, /hotels, /trains; localStorage only on generic routes.
   *  A tap keeps its tab until the URL matches, so the page cannot flash the old tab. */
  useEffect(() => {
    const path = location.pathname;
    const formFromPath = formTypeFromHomepagePath(path);
    const requestedFormType = requestedFormTypeRef.current;
    const nextFormType = formTypeAfterHomepageNavigation(formFromPath, requestedFormType);
    if (requestedFormType && nextFormType === requestedFormType && formFromPath === requestedFormType) {
      requestedFormTypeRef.current = null;
    }

    if (nextFormType) {
      setActiveFormType(nextFormType);
      if (localStorage.getItem('yovo_active_form_type') !== nextFormType) {
        localStorage.setItem('yovo_active_form_type', nextFormType);
      }
      return;
    }

    const savedActiveForm = localStorage.getItem('yovo_active_form_type');
    if (savedActiveForm) {
      setActiveFormType(savedActiveForm);
    }
  }, [location.pathname]);

  // Listen for storage changes (when header updates localStorage)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key !== 'yovo_active_form_type' || !e.newValue) return;
      const next = homepageFormTypeFromStorage(formTypeFromHomepagePath(location.pathname), e.newValue);
      if (!next) return;
      setActiveFormType(next);
    };

    /** Same-tab sync: YovoTripHeader dispatches this when user taps Flights/Trains/Stays (storage event only fires across tabs). */
    const handleLocalStorageCustom = (e) => {
      const stored = e.detail?.newValue;
      if (e.detail?.key !== 'yovo_active_form_type' || !stored) return;
      const next = homepageFormTypeFromStorage(formTypeFromHomepagePath(location.pathname), stored);
      if (!next) return;
      setActiveFormType(next);
    };

    const checkLocalStorage = () => {
      const next = homepageFormTypeFromStorage(
        formTypeFromHomepagePath(location.pathname),
        localStorage.getItem('yovo_active_form_type'),
      );
      if (next && next !== activeFormType) {
        setActiveFormType(next);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageChange', handleLocalStorageCustom);
    window.addEventListener('focus', checkLocalStorage);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleLocalStorageCustom);
      window.removeEventListener('focus', checkLocalStorage);
    };
  }, [location.pathname, activeFormType]);

  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [chatbotInputText, setChatbotInputText] = useState('');
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const showHomepageChatbotSidebar = SHOW_CHATBOT_SIDEBAR_ON_MOBILE || isMdUp;

  const fullText = "Hey, It's Yovo, your AI travel guide. How can I help you today?";
  const visibleText = fullText;
  const [trending_international_destinations, setTrending_international_destinations] = useState([]);
  const [weekend_getaways, setWeekend_getaways] = useState([]);
  const [visa_free_destinations, setVisa_free_destinations] = useState([]);
  const [seasonal_destinations, setSeasonal_destinations] = useState([]);
  const [trending_trips,setTrending_trips] = useState([]);
  const [sectionMeta, setSectionMeta] = useState({});
  const [sectionsLoading, setSectionsLoading] = useState(true);

  const [gradientAnimationPlayed, setGradientAnimationPlayed] = useState(false);
  const aiGuideContentRef = useRef(null);
  const [aiGuideContentHeight, setAiGuideContentHeight] = useState(null);
  const [regionalSettingsOpen, setRegionalSettingsOpen] = useState(false);
  // Get authentication status
  const { isAuthenticated } = useAuth();

  // Create array of first items from each of the 5 sections for Popular Places
  const popularPlacesFromSections = useMemo(() => {
    const sections = [];
    
    // Get first item from each section if available
    if (trending_trips && trending_trips.length > 0) {
      sections.push(trending_trips[0]);
    }
    if (trending_international_destinations && trending_international_destinations.length > 0) {
      sections.push(trending_international_destinations[0]);
    }
    if (weekend_getaways && weekend_getaways.length > 0) {
      sections.push(weekend_getaways[0]);
    }
    if (visa_free_destinations && visa_free_destinations.length > 0) {
      sections.push(visa_free_destinations[0]);
    }
    if (seasonal_destinations && seasonal_destinations.length > 0) {
      sections.push(seasonal_destinations[0]);
    }
    
    return sections;
  }, [trending_trips, trending_international_destinations, weekend_getaways, visa_free_destinations, seasonal_destinations]);

  // Helper function to handle chatbot input send
  const handleChatbotSend = () => {
    const msg = chatbotInputText.trim();
    if (!msg) return;
    if (!showHomepageChatbotSidebar) {
      window.chatbotInitialMessage = msg;
      setChatbotOpen(true);
    } else if (window.openChatbot) {
      window.openChatbot(msg);
    }
    setChatbotInputText('');
  };

  // Helper function to handle Enter key press
  const handleChatbotKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatbotSend();
    }
  };

  // Trigger gradient animation on mount
  useEffect(() => {
    setGradientAnimationPlayed(true);
  }, []);

  // (Old section cache functions removed — using single API with sessionStorage cache now)

useEffect(() => {
  const fetchHomepageSections = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/destination/homepage-sections`);
      if (!res.ok) throw new Error('Failed to fetch homepage sections');
      const json = await res.json();

      if (json.success && json.sections) {
        const mapped = applyHomepageSections(json.sections);
        startTransition(() => {
          setSectionMeta(mapped.meta);
          setTrending_trips(mapped.trending);
          setTrending_international_destinations(mapped.international);
          setWeekend_getaways(mapped.weekend);
          setVisa_free_destinations(mapped.visaFree);
          setSeasonal_destinations(mapped.seasonal);
          setSectionsLoading(false);
        });
        return;
      }
      startTransition(() => {
        setSectionsLoading(false);
      });
    } catch (error) {
      console.error('Error fetching homepage sections:', error);
      startTransition(() => {
        setTrending_trips([]);
        setTrending_international_destinations([]);
        setWeekend_getaways([]);
        setVisa_free_destinations([]);
        setSeasonal_destinations([]);
        setSectionsLoading(false);
      });
    }
  };

  fetchHomepageSections();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [])
  // Cache functions for IP/Location API
  const getLocationCacheKey = useCallback(() => {
    return 'homepage_user_location';
  }, []);

  const getCachedLocation = useCallback(() => {
    try {
      const cacheKey = getLocationCacheKey();
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsedCache = JSON.parse(cached);
        const cacheAge = Date.now() - parsedCache.timestamp;
        const maxAge = 24 * 60 * 60 * 1000; // 24 hours (location doesn't change often)
        if (cacheAge < maxAge) {
          return parsedCache.data;
        } else {
          sessionStorage.removeItem(cacheKey);
        }
      }
    } catch (error) {
      console.error('Error reading location cache:', error);
    }
    return null;
  }, [getLocationCacheKey]);

  const cacheLocation = useCallback((locationData) => {
    try {
      const cacheKey = getLocationCacheKey();
      const cacheData = {
        data: locationData,
        timestamp: Date.now()
      };
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error caching location:', error);
    }
  }, [getLocationCacheKey]);

  useEffect(() => {
    // Check cache first for user location
    const cachedLocation = getCachedLocation();
    if (cachedLocation) {
      return;
    }

    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        // console.log('User IP Address:', data);
        const userIP = data.ip;
        fetch(`https://ipapi.co/${userIP}/json/`)
          .then(response => response.json())
          .then(data => {
            // console.log('City:', data.city);
            const locationData = {
              city: data.city,
              state: data.region,
              country: data.country_name,
              latitude: data.latitude,
              longitude: data.longitude
            };
            cacheLocation({
              location: locationData,
              ip: userIP
            });
            
            fetchData('Store_Flight_Results', {
              Measure:"Location_Data",
              User_City:data.city,
              User_State:data.region,
              User_Country:data.country_name,
              User_Latitude:data.latitude,
              User_Longitude:data.longitude
            }).catch((error) => {
              console.error('Error storing location data:', error);
            });
          })
          .catch(error => console.log('Error fetching location:', error));
      })
      .catch(error => console.log('Error fetching IP:', error));
  // getCachedLocation and cacheLocation are stable useCallback functions
  // They don't need to be in dependencies as they're just utility functions
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Campaign API product follows active Homepage tab; trains has no campaign product. */
  const homepageCampaignProduct = useMemo(() => {
    if (shownFormType === 'flight') {
      return PRODUCTS.FLIGHTS;
    }
    if (shownFormType === 'hotel') {
      return PRODUCTS.HOTELS;
    }
    return null;
  }, [shownFormType]);

  /** Campaign session synced from HomepageBannerCoordinator (single fetch for banner + popup). */
  const [homepageCampaignSession, setHomepageCampaignSession] = useState({
    campaigns: [],
    status: /** @type {'idle'} */ ('idle'),
    viewport: /** @type {'desktop'} */ ('desktop'),
    onNavigate: () => false,
  });

  const handleHomepageCampaignData = useCallback((session) => {
    setHomepageCampaignSession(session);
  }, []);

  const homepageCampaigns = homepageCampaignSession.campaigns;
  const homepageCampaignStatus = homepageCampaignSession.status;
  const homepageCampaignViewport = homepageCampaignSession.viewport;
  const homepageCampaignNavigate = homepageCampaignSession.onNavigate;

  // Flight / train / hotel AI guide — side icon height tracks greeting + input block
  useEffect(() => {
    const usesPairedLayout = shownFormType === 'flight' || shownFormType === 'train' || shownFormType === 'hotel';
    if (!usesPairedLayout) {
      setAiGuideContentHeight(null);
      return undefined;
    }
    const node = aiGuideContentRef.current;
    if (!node || typeof ResizeObserver === 'undefined') return undefined;

    const syncHeight = () => {
      setAiGuideContentHeight(node.getBoundingClientRect().height);
    };

    syncHeight();
    const observer = new ResizeObserver(syncHeight);
    observer.observe(node);
    window.addEventListener('resize', syncHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', syncHeight);
    };
  }, [shownFormType, visibleText, gradientAnimationPlayed]);

  // Helper function to navigate to guide page — fetches full JSON on-demand
  const navigateToGuide = useCallback(async (category, placeData) => {
    const name = placeData?.hero?.title || placeData?.place?.name || placeData?.destination || '';
    const slug = slugify(name) || 'destination';

    try {
      const res = await fetch(`${BACKEND_URL}/api/destination/guide/${encodeURIComponent(name)}`);
      const json = await res.json();
      if (json.success && json.data) {
        navigate(`/destinations/${slug}`, {
          state: { placeData: json.data, category }
        });
        return;
      }
    } catch (_) { /* fallback to lightweight data */ }

    navigate(`/destinations/${slug}`, {
      state: { placeData, category }
    });
  }, [navigate]);

  const openDestinationGuide = useCallback((destination) => {
    navigateToGuide(destination.category, destination.output_json);
  }, [navigateToGuide]);

  // Helper function to handle popular place card clicks
  const handlePopularPlaceClick = (category, placeData) => {
    if (!category) {
      // If no category, navigate to guide page
      navigateToGuide(category, placeData);
      return;
    }

    const categoryLower = category.toLowerCase();
    let sectionId = null;

    for (const entry of sectionIdMap) {
      const dbTitle = (sectionMeta[entry.metaId]?.title || '').toLowerCase();
      if ((dbTitle && categoryLower.includes(dbTitle)) || 
          (dbTitle && dbTitle.includes(categoryLower)) ||
          entry.legacy.some(l => categoryLower.includes(l))) {
        sectionId = entry.domId;
        break;
      }
    }

    // If we found a matching section, scroll to it
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // If no matching section found, navigate to guide page
    navigateToGuide(category, placeData);
  };

  return (
    <>
    <PageHelmet
      fullTitle={SEO_DEFAULTS.homepageFullTitle}
      description={SEO_DEFAULTS.defaultDescription}
      path="/"
      jsonLd={buildHomepageSchema({
        pageTitle: SEO_DEFAULTS.homepageFullTitle,
        description: SEO_DEFAULTS.defaultDescription,
      })}
    />
    <Box
      className="homepage-root"
      data-homepage-ready="true"
      sx={homepageRootSx}
    >
      
      {/* Main Content */}
      <Box
        sx={homepageContentSx(chatbotOpen && showHomepageChatbotSidebar)}
      >
        {/* Header - Common Header Component */}
        {/* Desktop/Tablet header — hidden on mobile.
           display:contents on sm+ so the sticky header's containing block is the
           tall flex parent, giving position:sticky enough room to actually stick. */}
        <Box
          className="homepage-yovo-header-host"
          sx={homepageHeaderHostSx}
        >
          <YovoTripHeader
            activeFormType={activeFormType}
            onFormTypeChange={switchToForm}
          />
        </Box>
        {/* Mobile header — replaces YovoTripHeader + FlightOneWayRoundTripSearchBar on mobile */}
        <MobileHeader
          activeFormType={activeFormType}
          onFormTypeChange={switchToForm}
          onGlobeClick={() => setRegionalSettingsOpen(true)}
        />

        <Box
          component="main"
          sx={homepageMainSx}
        >
        {/* Reddish-Brown Hero Banner */}
        <FlightOneWayRoundTripSearchBar 
          tripType={flightFormState.tripType}
          multiCitySegments={flightFormState.multiCitySegments}
          icon={shownFormType}
        />

        {/* Main Background Section */}
        <Box
          id="yovo-homepage-main-card"
          sx={homepageSearchCardSx(shownFormType === 'hotel')}
        >
          {/*
            Homepage campaign layout (flex order):
            Mobile:  Form → Homepage Banner
            Desktop: Form → AI Initiative → Homepage Banner
          */}
          <Box sx={homepageFormColumnSx}>
            {/* Search widget — overlaps red hero banner on desktop */}
            <Box sx={homepageSearchSlotSx}>
              {shownFormType === 'flight' ? (
                <FlightForm
                  onStateChange={handleFlightFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              ) : shownFormType === 'train' ? (
                <TrainForm
                  onStateChange={handleTrainFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              ) : (
                <HotelForm
                  onStateChange={handleHotelFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              )}
            </Box>

            {/* AI Initiative — desktop only */}
            <Box sx={homepageAiGuideSx({
              isHotel: shownFormType === 'hotel',
              isMulticity: shownFormType === 'flight' && flightFormState.tripType === 'multicity',
            })}>
            <Box sx={homepageAiGuideClusterSx}>
            <Typography
              component="h1"
              sx={homepageAiGuideTitleSx}
            >
              <AutoAwesome sx={homepageAiGuideIconSx} />
              {visibleText}
            </Typography>

            <Box
              sx={homepageAiGuideRowSx}
              className="homepage-ai-travel-guide-row homepage-ai-travel-guide-row--paired"
            >
              <Box
                className="homepage-ai-travel-guide-content"
                ref={aiGuideContentRef}
              >
                {/* Search Input */}
                <Box 
                className={gradientAnimationPlayed ? 'gradient-border-animate' : ''}
                sx={homepageAiGuideInputSx()}>
                  <input
                    type="text"
                    placeholder="If you could teleport right now... where's your dream stop?"
                    value={chatbotInputText}
                    onChange={(e) => setChatbotInputText(e.target.value)}
                    onKeyPress={handleChatbotKeyPress}
                    autoComplete="off"
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      border: 'none',
                      outline: 'none',
                      fontFamily: HOST_GROTESK_FAMILY,
                      fontWeight:'400',
                      fontSize: '16px',
                      color: '#333',
                      background: 'transparent',
                      opacity: 1
                    }}
                  />
                  <Box 
                    onClick={handleChatbotSend}
                    sx={homepageAiGuideSendSx}>
                    <Box 
                      component="img"
                      src={playicon}
                      alt="Send"
                      sx={homepageAiGuideSendIconSx}
                    />
                  </Box>
                </Box>
              </Box>

              {shouldRenderHomepageMascot(isMdUp) && (shownFormType === 'flight' || shownFormType === 'train' || shownFormType === 'hotel') && (
                <Box
                  className={
                    shownFormType === 'flight'
                      ? 'homepage-ai-travel-guide-side-visual homepage-ai-travel-guide-mascot'
                      : 'homepage-ai-travel-guide-side-visual'
                  }
                  aria-hidden="true"
                  sx={homepageAiGuideMascotSx(aiGuideContentHeight)}
                >
                  <img
                    src={
                      shownFormType === 'train'
                        ? train_homepage_icon
                        : shownFormType === 'hotel'
                          ? hotel_icon
                          : woman_icon_without_bg
                    }
                    alt=""
                  />
                </Box>
              )}
            </Box>
            </Box>
          </Box>

            {/* Homepage Banner — campaign carousel (Banner Web / Mobile) */}
            <Box sx={homepageBannerSlotSx}>
              <Suspense fallback={null}>
                <HomepageBannerCoordinator
                  product={homepageCampaignProduct}
                  onCampaignData={handleHomepageCampaignData}
                />
              </Suspense>
            </Box>
          </Box>
        </Box>

        {/* The skeleton holds the gallery's space while its chunk loads, so the sections below do not jump (CLS). */}
        <Suspense
          fallback={sectionsLoading || popularPlacesFromSections.length > 0 ? <DestinationGallerySkeleton /> : null}
        >
          <DestinationGalleryGrid
            places={popularPlacesFromSections}
            loading={sectionsLoading}
            onPlaceClick={handlePopularPlaceClick}
          />
        </Suspense>

        <style>{datePickerStyles}</style>
        <TrendingSpotlightSection
          sectionId="nearby-treasures-section"
          title={sectionMeta[1]?.title || TRENDING_SPOTLIGHT_TITLE_FALLBACK}
          description={sectionMeta[1]?.subtitle || TRENDING_SPOTLIGHT_DESCRIPTION_FALLBACK}
          items={trending_trips}
          loading={sectionsLoading}
          onExplore={openDestinationGuide}
          icon={TrendingUpIcon}
          iconColor={TRENDING_SPOTLIGHT_ICON_COLOR}
        />

        {/* Main Content Area */}

      {chatbotOpen && (
      <Suspense fallback={null}>
      <MobileChatbotOverlay
        open={chatbotOpen}
        setOpen={setChatbotOpen}
        sidebarOnMd={showHomepageChatbotSidebar}
      />
      </Suspense>
      )}

      {/* Unified homepage popup — conv fee promo + campaign modals in one carousel */}
      {/*<HomepagePopup*/}
      {/*  pathname={location.pathname}*/}
      {/*  isAuthenticated={isAuthenticated}*/}
      {/*  campaigns={homepageCampaigns}*/}
      {/*  status={homepageCampaignStatus}*/}
      {/*  viewport={homepageCampaignViewport}*/}
      {/*  product={homepageCampaignProduct}*/}
      {/*  onNavigate={homepageCampaignNavigate}*/}
      {/*/>*/}

      {/* Regional Settings Modal */}
      <MountWhenOpened open={regionalSettingsOpen}>
      <RegionalSettingsModal
        open={regionalSettingsOpen}
        onClose={() => setRegionalSettingsOpen(false)}
        onSave={(settings) => {
          console.log('✅ Regional settings saved:', settings);
          
          // Clear all flight-related caches to force new API calls with new currency
          // 1. Clear in-memory flight cache
          if (window.flightCache) {
            window.flightCache.clear();
          }
          
          // 2. Clear sessionStorage cache for flight results
          try {
            const sessionKeys = Object.keys(sessionStorage);
            sessionKeys.forEach(key => {
              // Clear flight search cache entries
              if (key.startsWith('flight_search_') || 
                  key.startsWith('flight_results_') ||
                  key.startsWith('multicity_flight_') ||
                  key.startsWith('historical_prices_')) {
                sessionStorage.removeItem(key);
              }
            });
            console.log('✅ Cleared flight search cache from sessionStorage');
          } catch (error) {
            console.error('❌ Error clearing sessionStorage cache:', error);
          }
          
          // 3. Dispatch a custom event to notify other components about currency change
          // This allows FlightSelect and other components to react to currency changes
          window.dispatchEvent(new CustomEvent('currencyChanged', { 
            detail: { currency: settings.currency } 
          }));
          
          console.log(`✅ Currency changed to ${settings.currency}. All caches cleared. New searches will use the new currency.`);
        }}
      />
      </MountWhenOpened>


      {/* Bucket List — data comes from the shared homepage-sections fetch */}
      <NearViewport sectionId="global-hotspots-section">
        <FeaturedDestinationSection
          sectionId="global-hotspots-section"
          title={sectionMeta[2]?.title || BUCKET_LIST_TITLE_FALLBACK}
          description={sectionMeta[2]?.subtitle || BUCKET_LIST_DESCRIPTION_FALLBACK}
          items={trending_international_destinations}
          loading={sectionsLoading}
          onExplore={openDestinationGuide}
          icon={FlightTakeoffIcon}
          iconColor={BUCKET_LIST_ICON_COLOR}
        />
      </NearViewport>
      {/* Tropical Paradise — data comes from the shared homepage-sections fetch */}
      <NearViewport sectionId="weekend-collection-section">
        <FeaturedDestinationSection
          sectionId="weekend-collection-section"
          title={sectionMeta[3]?.title || TROPICAL_PARADISE_TITLE_FALLBACK}
          description={sectionMeta[3]?.subtitle || TROPICAL_PARADISE_DESCRIPTION_FALLBACK}
          items={weekend_getaways}
          loading={sectionsLoading}
          onExplore={openDestinationGuide}
          iconColor={TROPICAL_PARADISE_ICON_COLOR}
        />
      </NearViewport>

      {/* Into the Wild — data comes from the shared homepage-sections fetch */}
      <NearViewport sectionId="visa-free-wonders-section">
        <FeaturedDestinationSection
          sectionId="visa-free-wonders-section"
          title={sectionMeta[4]?.title || INTO_THE_WILD_TITLE_FALLBACK}
          description={sectionMeta[4]?.subtitle || INTO_THE_WILD_DESCRIPTION_FALLBACK}
          items={visa_free_destinations}
          loading={sectionsLoading}
          onExplore={openDestinationGuide}
          icon={MapIcon}
          iconColor={INTO_THE_WILD_ICON_COLOR}
        />
      </NearViewport>

      {/* Hidden Gems — data comes from the shared homepage-sections fetch */}
      <NearViewport sectionId="seasons-finest-section">
        <FeaturedDestinationSection
          sectionId="seasons-finest-section"
          title={sectionMeta[5]?.title || HIDDEN_GEMS_TITLE_FALLBACK}
          description={sectionMeta[5]?.subtitle || HIDDEN_GEMS_DESCRIPTION_FALLBACK}
          items={seasonal_destinations}
          loading={sectionsLoading}
          onExplore={openDestinationGuide}
          icon={AcUnitIcon}
          iconColor={HIDDEN_GEMS_ICON_COLOR}
        />
      </NearViewport>

      {/* Testimonials */}
      <Box
        component="section"
        aria-label="Customer testimonials"
        sx={homepageTestimonialsSx}
      >
        <Box
          sx={homepageTestimonialsInnerSx}
        >
          <Suspense fallback={null}>
            <TestimonialsSection variant="homepage" id="homepage-testimonials" />
          </Suspense>
        </Box>
      </Box>

      {/* YovoTrip Promise + FAQ Section */}
      <Box 
        component="section" 
        className="homepage-faq-section" 
        aria-labelledby="homepage-faq-title" 
        sx={homepageFaqSx}
      >
        {/* The YovoTrip Promise - Premium Trust Cards + App Banner */}
        <Suspense fallback={null}>
        <FAQTrustStrip 
          items={FAQ_TRUST_ITEMS.homepage} 
          variant="homepage" 
          showAppBanner={true}
        />
        
        <FAQSection
          faqs={HOME_FAQS}
          variant="homepage"
          title="Frequently Asked Questions"
          subtitle="Everything you need to know before booking with YovoTrip."
          titleId="homepage-faq-title"
          defaultOpen={0}
          maxItems={HOME_FAQ_PREVIEW_COUNT}
          showViewAll={true}
          viewAllLink="/faqs"
          viewAllText="View all FAQs"
        />
        </Suspense>
        
        {/* FAQ Schema for SEO */}
        <FAQJsonLd faqs={HOME_FAQS} pageName="YovoTrip FAQs" />
      </Box>
        </Box>

      {/* Footer */}
      <Suspense fallback={null}>
        <GlobalFooter variant="full" />
      </Suspense>

      {/* Mobile bottom nav — portaled to document.body; render after page content */}
      <MobileBottomNav
        assistActive={chatbotOpen}
        onAssistClick={(initialMessage) => {
          if (initialMessage) window.chatbotInitialMessage = initialMessage;
          setChatbotOpen(true);
        }}
        onDismissAssist={() => setChatbotOpen(false)}
      />

      </Box>{/* end inner flex container (sticky header containing block) */}
      </Box>{/* end outer wrapper */}
      </>
    // </Box>
  );
};

export default Homepage;
